import { decodeDocument, fileToBase64, formatDate } from '@/utils/utils';
import { formatDateForInput } from '@/utils/filters';

export default {
    async createSixthOrAmendmentStepUpdateRequest(formData, additionalFormData, isAmendmentFormData = false) {
        let requestData = {
            insurerName: formData.insurerName,
            contractNumber: formData.contractNumber,
            productsAndOptionsChosen: formData.productsAndOptionsChosen,
            contractStartDate: formatDate(formData.contractStartDate),
        };

        let request = {
            ...requestData,
            ...additionalFormData
        }

        for (const [key] of Object.entries(this.getDocumentFieldNames())) {
            if (formData[key]) {
                request[key] = await fileToBase64(formData[key]);
            }
        }

        if (!isAmendmentFormData) {
            for (const [key] of Object.entries(this.getDocumentFieldNames())) {
                if (!formData[key]) {
                    request.propertiesToNull.push(key);
                }
            }
        }

        if (null !== formData.isOptionalContractAvailable) {
            request.isOptionalContractAvailable = formData.isOptionalContractAvailable;
        }

        if (formData.optionalContractNumber) {
            request.optionalContractNumber = formData.optionalContractNumber;
        }

        if (null !== formData.eligiblePartiesContribution) {
            request.eligiblePartiesContribution = formData.eligiblePartiesContribution;
        }

        if (null !== formData.employerContribution) {
            request.employerContribution = formData.employerContribution;
        }

        return request
    },
    async createFormDataFromResponse(response) {
        let formData = {};

        if (response.insurerName) {
            formData.insurerName = response.insurerName;
        }

        if (response.contractNumber) {
            formData.contractNumber = response.contractNumber;
        }

        if (response.productsAndOptionsChosen) {
            formData.productsAndOptionsChosen = response.productsAndOptionsChosen;
        }

        if (response.contractStartDate) {
            formData.contractStartDate = formatDateForInput(response.contractStartDate);
        }

        for (const [key, value] of Object.entries(this.getDocumentFieldNames())) {
            if (response[key]) {
                const decodedFile = await decodeDocument({
                    typeCode: value,
                    content: response[key].content
                })
                formData[key] = decodedFile.content;
            }
        }

        if (null !== response.isOptionalContractAvailable) {
            formData.isOptionalContractAvailable = response.isOptionalContractAvailable;
        }

        if (response.optionalContractNumber) {
            formData.optionalContractNumber = response.optionalContractNumber;
        }

        if (null !== response.eligiblePartiesContribution) {
            formData.eligiblePartiesContribution = response.eligiblePartiesContribution;
        }

        if (null !== response.employerContribution) {
            formData.employerContribution = response.employerContribution;
        }

        return formData;
    },
    getDocumentFieldNames() {
        return {
            'particularConditions': 'PC',
            'copyOfInformationNote': 'COI',
            'particularConditionsForOptionalContract': 'PCF',
            'copyOfInformationNoteForOptionalContract': 'COIF'
        };
    }
};
